import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import _ from 'lodash';

var shallowEqual = function shallowEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (!_.isObject(a) || a === null || !_.isObject(b) || b === null) {
    return false;
  }

  var keysA = Object.keys(a);
  var keysB = Object.keys(b);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);

  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || a[keysA[i]] !== b[keysA[i]]) {
      return false;
    }
  }

  return true;
};

var withPureRender = function withPureRender(Component) {
  var PureRender = /*#__PURE__*/function (_React$Component) {
    _inherits(PureRender, _React$Component);

    var _super = _createSuper(PureRender);

    function PureRender() {
      _classCallCheck(this, PureRender);

      return _super.apply(this, arguments);
    }

    _createClass(PureRender, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        return !shallowEqual(this.props, nextProps);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(Component, this.props);
      }
    }]);

    return PureRender;
  }(React.Component);

  PureRender.displayName = Component.displayName;
  return PureRender;
};

export default withPureRender;